export enum SeasonTabKeys {
  Fixtures = "fixtures",
  Stages = "stages",
  Pools = "pools",
  Series = "series",
  Entities = "entities",
  EntityImages = "entity-images",
  EntityStatistic = "entity-statistic",
  Officials = "officials",
  AssignOfficials = "assign-officials",
  Venues = "venues",
  Standings = "standings",
  FinalStandings = "final-standings",
  Reports = "reports",
  Details = "details",
}
